export default "__VITE_ASSET__C1FMR_2n__"